import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { GlgButton } from 'Shared/components'
import BaseCloningModal from './BaseCloningModal'
import { setCloningModal, selectOutdatedLeagues } from '../../../reducers/cloning_steps'

const OutdatedLeaguesModal = () => {
  const dispatch = useDispatch()
  const outdatedLeagues = useSelector(selectOutdatedLeagues)

  const modalContent = (
    <>
      <span>{window.I18n.t('clone_leagues_sessions.modals.outdated_leagues.content')}</span>
      <ul className={'cls-steps-modal__outdated-list'}>
        {outdatedLeagues.map(league => (
          <li key={league.id}>{league.name}</li>
        ))}
      </ul>
    </>
  )

  return (<BaseCloningModal
    title={window.I18n.t('clone_leagues_sessions.modals.outdated_leagues.title')}
    content={modalContent}
    rightButton={<GlgButton
      className={'cls-steps-modal__right_button'}
      text={window.I18n.t('clone_leagues_sessions.modals.outdated_leagues.acknowledge')}
      onClick={() => dispatch(setCloningModal(null))}
    />}
  />)
}

export default OutdatedLeaguesModal
